import request from '../utils/request';

// 分页查询陪逛服务评价
export const listAccompanyShoppingReviews = (params) => {
  return request({
    url: '/accompany-shopping-review/list',
    method: 'get',
    params
  });
};

// 查询单个陪逛服务评价详情
export const getAccompanyShoppingReviewById = (id) => {
  return request({
    url: `/accompany-shopping-review/${id}`,
    method: 'get'
  });
};

// 删除陪逛服务评价
export const deleteAccompanyShoppingReview = (id) => {
  return request({
    url: `/accompany-shopping-review/${id}`,
    method: 'delete'
  });
}; 